import { render, staticRenderFns } from "./ControlView.vue?vue&type=template&id=3bcc6e84&scoped=true"
import script from "./ControlView.vue?vue&type=script&lang=js"
export * from "./ControlView.vue?vue&type=script&lang=js"
import style0 from "./ControlView.vue?vue&type=style&index=0&id=3bcc6e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcc6e84",
  null
  
)

export default component.exports